import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'
import { formatHour } from '@/utils'
import { inventoryDay } from '@/const'

import time from './modules/time'
import config from './modules/config'
import user from './modules/user'
import storeModule from './modules/storeModule'
import global from './modules/global'
import admin from './modules/admin'
import recipes from './modules/recipes'
import vendorProducts from './modules/vendorProducts'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  getters: {
    currentDayHours: (state, getters) => {
      let day = getters['time/weekDay']
      // hours_day.length === # of shifts + 1
      let hours = getters['storeModule/data'][`hours_${day}`]
      if (!hours) return null
      hours = hours.slice(0)
      return hours
    },
    currentShift: (state, getters) => {
      // should only return 0, 1, 2, 3... (up to # of shifts)
      let hours = getters['currentDayHours']
      if (!hours) return null
      let hour = getters['time/hour']
      if (hour < hours[0] || hour >= hours[hours.length - 1]) return null
      let shift = hours.findIndex((time, index) => {
        return (hour < time && index > 0) || index + 2 > hours.length
      })
      // shifts are labeled 0, 1, 2...not 1, 2, 3...
      return shift - 1
    },
    currentShiftName: (state, getters) => {
      if (!getters['storeModule/shifts']) return null
      if (getters['currentShift'] === null) {
        return 'Closed'
      } else {
        return getters['storeModule/shifts'][getters['currentShift']]
      }
      // return getters['storeModule/shifts'][getters['currentShift'] || 0]
    },
    currentShiftHours: (state, getters) => {
      if (!getters['currentDayHours']) return ''
      if (getters['currentShift'] === null) return ''
      let start = formatHour(
        getters['currentDayHours'][getters['currentShift']]
      )
      let end = formatHour(
        getters['currentDayHours'][getters['currentShift'] + 1]
      )
      return `${start} - ${end}`
    },
    shiftLogsPastDue: (state, getters) => {
      let arr = []
      for (let i = getters['currentShift'] - 1; i > -1; i--) {
        if (
          getters['storeModule/tasksRemainingByShifts'][i] &&
          getters['storeModule/tasksRemainingByShifts'][i].length > 0
        )
          arr.push(i)
      }
      return arr
    },
    orderItemsToday: (state, getters) => {
      try {
        return getters['storeModule/productsByDays'][
          getters['time/weekDayName']
        ]
      } catch {
        return []
      }
    },
    orderItemsRemaining: (state, getters) => {
      // ADD: CLEAN UP
      if (!getters['storeModule/currentOrder']) return []
      let weekDay = getters['time/weekDay']
      if (typeof weekDay !== 'number') return []
      // console.log(
      //   getters.orderItemsToday,
      //   getters['time/weekDay'],
      //   getters['time/weekDayName'],
      //   getters['storeModule/productsByDays']
      // )
      let orderItems = [...getters['orderItemsToday']]
      try {
        let order = { ...getters['storeModule/currentOrder'] }
        if (order.completed) return []
        return orderItems.filter((item) => {
          try {
            return Object.prototype.hasOwnProperty.call(order, item)
              ? false
              : true
          } catch {
            return false
          }
        })
      } catch {
        return []
      }
    },
    isTodayInventoryDay: function (state, getters) {
      return getters['time/weekDay'] == inventoryDay
    }
  },
  actions: {
    createNewOrder({ dispatch, getters }) {
      if (getters['time/weekDay'] == inventoryDay) {
        // if an expired (incomplete) order still exists, remove it
        dispatch('storeModule/deleteCurrentOrder')
        return dispatch('storeModule/createNewInventory').then((data) => ({
          success: true,
          data,
          message: 'New inventory successfully created.'
        }))
      } else if (getters['orderItemsToday'].length > 0) {
        return dispatch('storeModule/createNewOrder').then((data) => ({
          success: true,
          data,
          message: 'New order successfully created.'
        }))
      } else {
        return Promise.resolve({
          success: false,
          data: null,
          message:
            'Cannot create new order. No vendors take orders today and it is not an inventory day.'
        })
      }
    },
    async switchStores({ getters, dispatch }, storeName) {
      if (storeName === getters['storeModule/id'])
        throw `Can not switch stores: ${storeName} is already the users current store.`
      //if (!storeName) storeName = getters['user/storeName']
      //if (!storeName) throw 'No storeName provided!'

      console.log('index/switchStores ', storeName)
      dispatch('config/setLoading', true, { root: true })
      dispatch('config/setDataLoaded', false, { root: true })

      try {
        await dispatch('user/updatePrimaryStore', storeName)
      } catch (error) {
        dispatch('config/setLoading', false, { root: true })
        dispatch('config/setDataLoaded', true, { root: true })
        return Promise.reject(error)
      }

      try {
        await Promise.all([
          dispatch('storeModule/bindStore', { storeId: storeName }),
          dispatch('recipes/bindStore'),
          dispatch('vendorProducts/bindStore')
        ])
      } catch (error) {
        dispatch('config/setDataLoaded', true, { root: true })
        dispatch('config/setLoading', false, { root: true })
        return Promise.reject(error)
      }

      dispatch('config/setDataLoaded', true, { root: true })
      dispatch('config/setLoading', false, { root: true })

      console.log('returning Promise')
      return Promise.resolve
    }
    // async archiveStore(context) {
    //   let stores = [
    //     'testing2',
    //     'QMA3fmuFDhmoYhO3iTE0',
    //     'iXQnQK0AwBcNfE3AitHo',
    //     't18jILFOYT9rfeOKlow3'
    //   ]

    //   stores.forEach(store => {
    //     db.collection('stores').doc(store).get().then(doc => {
    //       if ( doc && doc.exists) {
    //         db.collection('history').doc(
    //       }
    //     })
    //   })
    // }
    // async copyStore(context, { storeFrom, storeTo }) {
    //Move all data from one store to another
    // db.collection('stores')
    //   .doc(storeFrom)
    //   .get()
    //   .then(doc => {
    //     if (doc && doc.exists) {
    //       db.collection('stores')
    //         .doc(storeTo)
    //         .set(
    //           {
    //             ...doc.data(),
    //             currentInventory: '',
    //             currentInvoices: [],
    //             currentLog: '',
    //             currentOrder: '',
    //             id: storeTo,
    //             name: storeTo
    //           },
    //           { merge: true }
    //         )
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //     return
    //   })
    // db.collection('stores')
    //   .doc(storeFrom)
    //   .collection('vendors')
    //   .get()
    //   .then(querySnapshot => {
    //     querySnapshot.docs.map(doc => {
    //       let docData = doc.data()
    //       db.collection('stores')
    //         .doc(storeTo)
    //         .collection('vendors')
    //         .doc(docData.id)
    //         .set({ ...docData })
    //     })
    //   })
    //   .catch(error => {
    //     console.log(error)
    //     return
    //   })
    // db.collection('stores')
    //   .doc(storeFrom)
    //   .collection('products')
    //   .get()
    //   .then(querySnapshot => {
    //     querySnapshot.docs.map(doc => {
    //       let docData = doc.data()
    //       db.collection('stores')
    //         .doc(storeTo)
    //         .collection('products')
    //         .doc(docData.id)
    //         .set({ ...docData })
    //     })
    //   })
    //   .catch(error => {
    //     console.log(error)
    //     return
    //   })
    // db.collection('stores')
    //   .doc(storeFrom)
    //   .collection('tasks')
    //   .get()
    //   .then(querySnapshot => {
    //     querySnapshot.docs.map(doc => {
    //       let docData = doc.data()
    //       db.collection('stores')
    //         .doc(storeTo)
    //         .collection('tasks')
    //         .doc(docData.id)
    //         .set({ ...docData })
    //     })
    //   })
    //   .catch(error => {
    //     console.log(error)
    //     return
    //   })
    // }
  },
  mutations: {
    ...vuexfireMutations
  },
  modules: { time, config, user, storeModule, global, admin, recipes, vendorProducts }
})

Vue.use(store) // ?

export default store

// STATE
// - prefer initializing with all the fields upfront, for reactivity
// - when adding new properties to an object, use either:
//    -- Vue.set(obj, 'newProp', 123), or
//    -- state.obj = { ...state.obj, newProp: 123 } (replaces with a fresh object)

// MUTATIONS
// RULES:
// - keep mutations synchronous
// - only recieve state and one parameter (preferably an object)

// GETTERS
// cached & reloaded based on dependancies

// ACTIONS
// - actions receive a context object, which has access to the store methods/properties, and one parameter
//    -- commit (for mutations), state, getters, and dispatch (to call other actions!)
// - context object can be destructured so that store.commit and be simplified to commit
// - can be asynchronous, unlike mutations\

// set vs update (create, add?)
//
// set without merge will overwrite a document or create it if it doesn't exist yet
// set with merge will update fields in the document or create it if it doesn't exists
// update will update fields but will fail if the document doesn't exist
// update might not update nested fields properly...
// create will create the document but fail if the document already exists
//
// set requires full document shaped format:
//  set({a: {b: {c: true}}}, {merge: true})
// update can take field paths:
//  update({'a.b.c': true})

// function setState(state, payload) {
//   for (var each in payload) {
//     state[each] =
//       typeof payload[each] === 'object' ? { ...payload[each] } : payload[each]
//   }
// }
